import { merge } from '../../helper';

import exLanguage from '../../language';
import * as exCustom from '../../custom';

import * as exModal from './modal';

// ----------------------------------------------------------------------------

export type TypeModalListing = {
    merge?: any;
    title?: string;
    textAction?: string;
    listing?: any;
};

// ----------------------------------------------------------------------------

function listing(config: TypeModalListing = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        modalHeader: {
            title: {
                html: config.title ?? exLanguage.line('modal.title'),
            },
        },
        buttons: [
            {
                html: config.textAction ?? exLanguage.line('general.ok'),
            },
        ],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = exModal.start({
        merge: defConfig,
        destroy: true,
    });

    // ------------------------------------------------------------------------

    // Create element (datatable)
    exCustom.datatable.create({
        merge: defConfig.listing,
        container: {
            parent: (modal as any).elements.body,
        },
    });

    // ------------------------------------------------------------------------

    // Return
    return modal;
}

// ----------------------------------------------------------------------------

export default listing;
